import DashboardNote from '../components/Admin/DashboardNote';
import { UserNoteTypeII } from '../types/types';
import { Box, Typography, Link, useTheme } from '@mui/material';
import DashboardNums from '../components/Admin/DashboardNums';

import RefreshIcon from '@mui/icons-material/Refresh';
import { ReactNode } from 'react';

interface MultiColumnCenterBoxProps {
  loading?: boolean;
  headingText?: string;
  headingComponent?: ReactNode;
  children?: ReactNode;
  showHeader?: boolean;
}

const MultiColumnCenterBox = ({
  loading,
  headingText,
  headingComponent,
  showHeader = true,
  children,
}: MultiColumnCenterBoxProps) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="multi-column-content"
      sx={{
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        bgcolor: 'backgroundColors.primary',
        border: 1,
        borderColor: 'borderColors.primary',
        borderRadius: '0.75rem',
        marginY: { xs: '2rem', sm: '2rem' },
        marginX: { xs: '.5rem', sm: '2rem' },
      }}
    >
      {showHeader && (
        <Box
          className="header-container"
          sx={{
            backgroundColor: 'backgroundColors.primary',
            borderBottom: 1,
            borderColor: 'borderColors.primary',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h2"
            color="textColors.lightHeader" sx={{ fontSize: "1.75rem", fontStyle: "normal", fontWeight: "700", lineHeight: "1.5rem", padding: "2rem 2.5rem" }}
          >
            {headingText}
          </Typography>
          {headingComponent}
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          minWidth: 0,
          flexDirection: { xs: 'column-reverse', md: 'row' },
        }}
      >
        {loading ? (
          <Typography
            variant="h2"
            color="textColors.lightHeader" sx={{ fontSize: "1.75rem", fontStyle: "normal", fontWeight: "700", lineHeight: "1.5rem", padding: "2rem 2.5rem" }}
          >
            Loading...
          </Typography>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};

export default MultiColumnCenterBox;
